export const INITIAL_STATE = {
  getWirecardInfoLoading: false,
  getWirecardInfoSuccess: null,
  getWirecardInfoFailure: null
}
